// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-summaries-container[data-v-ce66673c] {\n  max-height: calc(100vh - 6.5rem - 2rem - 2rem);\n  overflow-y: auto;\n  border: 1px solid var(--border-color);\n}", ""]);
// Exports
module.exports = exports;
